import { MetricSeries } from 'schemas/MetricSeriesSchema'
import { MetricSeriesStrings } from 'enums/MetricSeries'

const resolveMetricSeriesValue = (dataset: MetricSeries[], seriesName: MetricSeriesStrings) => {
  const metricSeriesEntry = dataset.find((series) => series.seriesName === seriesName)
  return metricSeriesEntry ? metricSeriesEntry.set![0]! : 0
}

export default resolveMetricSeriesValue
